import { registerComponent } from "helpers";

const EASTERN_TIME = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
  weekday: "short",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hourCycle: "h23",
});

export const SHIPPING_DAYS = new Set(["Mon", "Tue", "Wed", "Thu", "Fri"]);

export function getEasternTimeParts(date) {
  return Object.fromEntries(
    EASTERN_TIME.formatToParts(date)
      .filter((part) => part.type !== "literal")
      .map((part) => [part.type, part.value])
  );
}

export function getRemainingMinutes(cutoffHour, date = new Date()) {
  const parts = getEasternTimeParts(date);

  if (!SHIPPING_DAYS.has(parts.weekday)) return 0;

  const elapsedSeconds =
    Number(parts.hour) * 3600 +
    Number(parts.minute) * 60 +
    Number(parts.second);
  const remainingSeconds = cutoffHour * 3600 - elapsedSeconds;

  return Math.max(0, Math.ceil(remainingSeconds / 60));
}

function formatRemainingTime(totalMinutes) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
}

class ShippingCutoffTimer extends HTMLElement {
  connectedCallback() {
    this.cutoffHour = Number(this.dataset.cutoffHour) || 14;
    this.update();
    this.timer = window.setInterval(() => this.update(), 30000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  update() {
    const remainingMinutes = getRemainingMinutes(this.cutoffHour);

    if (remainingMinutes <= 0) {
      this.hidden = true;
      return;
    }

    const value = formatRemainingTime(remainingMinutes);

    this.querySelectorAll("[data-shipping-cutoff-time]").forEach((element) => {
      element.textContent = value;
    });

    this.hidden = false;
  }
}

registerComponent("shipping-cutoff-timer", ShippingCutoffTimer);
